import {
  DashboardOutlined,
  UserOutlined,
  CrownOutlined,
  TrophyOutlined,
  StarOutlined,
  OrderedListOutlined,
  BellOutlined,
  CalendarOutlined,
  BarChartOutlined,
} from '@ant-design/icons';
import master from './master';
import cms from './cms';

const menuItems = {
  items: [
    {
      id: 'overview',
      title: 'Overview',
      type: 'group',
      children: [
        { id: 'dashboard', title: 'Dashboard', type: 'item', url: '/dashboard', icon: DashboardOutlined },
      ],
    },
    {
      id: 'management',
      title: 'Management',
      type: 'group',
      children: [
        { id: 'users', title: 'User Management', type: 'item', url: '/users', icon: UserOutlined },
        { id: 'subscriptions', title: 'Subscription & Plans', type: 'item', url: '/subscriptions', icon: CrownOutlined },
        // { id: 'tournaments', title: 'Tournament & Challenges', type: 'item', url: '/tournaments', icon: TrophyOutlined },
        { id: 'leaderboard', title: 'Leaderboard ', type: 'item', url: '/leaderboard', icon: OrderedListOutlined },
        ...master.children,
      ],
    },
    
    {
      id: 'operations',
      title: 'Operations',
      type: 'group',
      children: [
        { id: 'Marathon', title: 'Marathon Management', type: 'item', url: '/marathon', icon: CalendarOutlined },
        { id: 'events', title: 'Event Management', type: 'item', url: '/events', icon: CalendarOutlined },
        // { id: 'notifications', title: 'Notification Management', type: 'item', url: '/notifications', icon: BellOutlined },
      ],
    },
    cms,
  ],
};

export default menuItems;
